// Libraries
import { FC } from "react";
import { Description } from "@radix-ui/react-dialog";

// Types
import { ModalSubtitleProps } from "./ModalSubtitle.types";

export const ModalSubtitle: FC<ModalSubtitleProps> = ({ children, className = "" }) => {
  const descriptionClassName = `font-inter text-muted-foreground text-left text-xs leading-snug ${className}`;

  if (children === null || children === undefined || typeof children === "boolean") {
    return null;
  }

  return (
    <Description asChild>
      <div className={descriptionClassName} data-testid="modal-subtitle">
        {children}
      </div>
    </Description>
  );
};

export default ModalSubtitle;
